//Core
import {AxiosResponse} from "axios";
//Builder
import clientBuilder from "@/services/clientBuilder";
//Redux
import {store} from "@/redux/store";
import {endFetch} from "@/redux/app/appSlice";
//Types
import {TFiltrationAPIRequest} from "@/types/services/filtration/request/filtrationAPIRequestTypes";
import {
    TFiltrationAPIResponse,
    TFiltrationAPIResponseData
} from "@/types/services/filtration/response/filtrationAPIResponseTypes";
//Utils
import {fetchListItems} from "@/utils/fetchListItems";


const filtrationClient = clientBuilder();

let returnData: TFiltrationAPIResponseData = {
    query_id: "",
    number_of_existing_wallets: 0,
    number_of_identified_wallets: 0,
    avg_wealth: 0
};
export const filtrationAPI = async (data: TFiltrationAPIRequest, signal?: AbortSignal) => {
    try {
        const response: AxiosResponse<TFiltrationAPIResponse> = await filtrationClient.post(
            `/filtration`,
            data,
            { signal } // Pass the AbortController's signal to the request
        );
        // console.log(response?.data?.data)
        if (response && response.data?.errors === 0) {
            returnData = response.data.data as TFiltrationAPIResponseData;
        }
        store.dispatch(endFetch(fetchListItems.filtration));
        return returnData;
    } catch (error: any) {
        console.log(error);
        if (error?.code !== "ERR_CANCELED") {
            store.dispatch(endFetch(fetchListItems.filtration));
        }
        return returnData;
    }
}